import { render } from "./DialogueCharts.vue?vue&type=template&id=395e06e2&scoped=true&ts=true"
import script from "./DialogueCharts.vue?vue&type=script&lang=ts"
export * from "./DialogueCharts.vue?vue&type=script&lang=ts"

import "./DialogueCharts.vue?vue&type=style&index=0&id=395e06e2&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395e06e2"]])

export default __exports__